import { render, staticRenderFns } from "./addlink.vue?vue&type=template&id=4b0dfcd2&lang=html"
import script from "./addlink.vue?vue&type=script&lang=js"
export * from "./addlink.vue?vue&type=script&lang=js"
import style0 from "./addlink.vue?vue&type=style&index=0&id=4b0dfcd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports